import { Badge, Box, DataList, DialogBody, Flex, FormatNumber, HStack, Image, LocaleProvider, Progress, Separator, Spinner, Stack, Table, Text } from "@chakra-ui/react";
import { UI } from "components";
import { Mask } from "config";
import { Styles } from "config";
import useDownline from "hooks/useDownline";
import useDownlinePoints from "hooks/useDownlinePoints";
import useUser from "hooks/useUser";
import { useEffect, useState } from "react";

export default function Downline({ data, ...props }){

    const user = useUser()
    const downline = useDownline(data?.id)
    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState('')
    const history = useDownlinePoints(data?.id, page, term)
    const pre_cache = useDownlinePoints(data?.id, page + 1, term)
    const vme = downline.data?.vme ?? {}
    const points = downline.data?.points ?? {}
    const career = downline.data?.career ?? {}

    const careerStyle = Styles.pin(career?.id)
    const progress_style = Styles.percentage_vme(vme.percentage)

    const columns = [{ children: 'Descrição' }, { children: 'Pontos' }, { children: 'Consultor' }, { children: 'Data', textAlign: 'right' }]

    useEffect(() => { setPage(1) }, [term])

    return(
    <UI.Dialog size="sm" title={downline.data?.name} loading={downline.isFetching} {...props}>
        <DialogBody>
            <Stack gap={4}>

                <UI.Show visible={downline.isFetching}><UI.Alert indicator={<Spinner />}>Carregando dados do downline...</UI.Alert></UI.Show>

                <HStack p={4} background={`${careerStyle.colorPalette}.muted`} borderRadius={4}>
                    <Image src={careerStyle.image_url} height={30} />
                    <Text fontSize="lg" fontWeight="bold">{career?.title}</Text>
                </HStack>
                
                <Box>
                    <Text color="GrayText" fontSize="sm">Pontos qualificáveis:</Text>
                    <Progress.Root striped animated value={vme?.percentage} size="xl" maxW="lg" mt={2} colorPalette={progress_style.colorPalette}>
                        <Progress.Track flex="1"><Progress.Range /></Progress.Track>
                        <Flex justifyContent="space-between" gap="2" mt={1}>
                            <Text fontSize="xs" fontWeight="300"><LocaleProvider locale="de-DE"><FormatNumber value={points.qualified / 100} /></LocaleProvider></Text>
                            <Text fontSize="xs" fontWeight="300"><LocaleProvider locale="de-DE"><FormatNumber value={user.data?.consultant?.career?.current_career?.vme / 100} /></LocaleProvider></Text>
                        </Flex>
                    </Progress.Root>
                </Box>

                <DataList.Root orientation="horizontal" gap={3}>
                    <DataList.Item>
                        <DataList.ItemLabel><UI.Icon name="network" /> Pontos da rede:</DataList.ItemLabel>
                        <DataList.ItemValue><LocaleProvider locale="de-DE"><FormatNumber value={points.liquid / 100} /></LocaleProvider></DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel><UI.Icon name="points" /> Pontos pessoais:</DataList.ItemLabel>
                        <DataList.ItemValue><LocaleProvider locale="de-DE"><FormatNumber value={points.personal / 100} /></LocaleProvider></DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel><UI.Icon name="points" /> Pontos qualificáveis:</DataList.ItemLabel>
                        <DataList.ItemValue color="green.fg"><LocaleProvider locale="de-DE"><FormatNumber value={points.qualified / 100} /></LocaleProvider></DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel><UI.Icon name="vme" /> Acima da VME:</DataList.ItemLabel>
                        <DataList.ItemValue color="orange.fg"><LocaleProvider locale="de-DE"><FormatNumber value={points.overflow / 100} /></LocaleProvider></DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel><UI.Icon name="anticipation" /> Antecipados:</DataList.ItemLabel>
                        <DataList.ItemValue color="red.fg"><LocaleProvider locale="de-DE"><FormatNumber value={points.anticipated / 100} /></LocaleProvider></DataList.ItemValue>
                    </DataList.Item>
                </DataList.Root>

                <Separator />
                <Text color="GrayText" fontSize="sm">Histórico de pontos</Text>

                <UI.Searchable placeholder="Procurar pelo código do pedido..." value={term} onChange={setTerm} disabled={history.isLoading} />
                <UI.Table variant="outline" size="sm" showColumnBorder loading={history.isLoading} loadingText="Carregando histórico de pontos..." columns={columns} data={history?.data?.data} meta={history.data?.meta} onPageChange={e => setPage(e.page)} Row={Row} />

            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}

const Row = ({ data }) => {
    return(
    <Table.Row>
        <Table.Cell fontSize="xs">{data?.order?.cod} {data?.order?.type === 3 && <Badge size="sm" colorPalette="orange">Adesão</Badge>}</Table.Cell>
        <Table.Cell><Badge size="sm" colorPalette="teal"><UI.Number.Number value={data?.points} /></Badge></Table.Cell>
        <Table.Cell fontSize="xs">{data?.order?.consultant?.customer?.name ?? 'Usuário Expirado'}</Table.Cell>
        <Table.Cell fontSize="xs">{Mask.dateTime(data?.created_at)}</Table.Cell>
    </Table.Row>
    )
}